package com.mxpainting.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.mxpainting.Strings
import com.mxpainting.rememberLanguage
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Carousel() {
    val language by rememberLanguage()

    Div(Modifier.classNames("container-fluid", "p-0", "mb-5", "wow", "fadeIn").id("header-carousel").toAttrs()) {
        Div(Modifier.classNames("carousel", "slide", "carousel-fade").toAttrs {
            attr("data-bs-ride", "carousel")
            attr("data-bs-interval", "5000")
        }) {
            Div(Modifier.classNames("carousel-inner").toAttrs()) {
                CarouselItem(
                    "/img/carousel_1.jpeg",
                    Strings.carousel1Title[language]!!,
                    Strings.carousel1Subtitle[language]!!,
                    Strings.carouselExplore[language]!!,
                    true
                )
                CarouselItem(
                    "/img/carousel_2.jpeg",
                    Strings.carousel2Title[language]!!,
                    Strings.carousel2Subtitle[language]!!,
                    Strings.carouselExplore[language]!!,
                    false
                )
                CarouselItem(
                    "/img/carousel_3.jpeg",
                    Strings.carousel3Title[language]!!,
                    Strings.carousel3Subtitle[language]!!,
                    Strings.carouselExplore[language]!!,
                    false
                )
                CarouselItem(
                    "/img/carousel_4.jpeg",
                    Strings.carousel4Title[language]!!,
                    Strings.carousel4Subtitle[language]!!,
                    Strings.carouselExplore[language]!!,
                    false
                )
            }
            
            Button(attrs = Modifier.classNames("carousel-control-prev").toAttrs {
                attr("data-bs-target", "#header-carousel")
                attr("data-bs-slide", "prev")
            }) {
                Span(Modifier.classNames("carousel-control-prev-icon").toAttrs { attr("aria-hidden", "true") }) {}
                Span(Modifier.classNames("visually-hidden").toAttrs()) { Text("Previous") }
            }
            
            Button(attrs = Modifier.classNames("carousel-control-next").toAttrs {
                attr("data-bs-target", "#header-carousel")
                attr("data-bs-slide", "next")
            }) {
                Span(Modifier.classNames("carousel-control-next-icon").toAttrs { attr("aria-hidden", "true") }) {}
                Span(Modifier.classNames("visually-hidden").toAttrs()) { Text("Next") }
            }
        }
    }
}

@Composable
private fun CarouselItem(imgSrc: String, title: String, subtitle: String, buttonText: String, active: Boolean) {
    val classes = mutableListOf("carousel-item")
    if (active) classes.add("active")
    
    Div(Modifier.classNames(*classes.toTypedArray()).toAttrs()) {
        Img(src = imgSrc, alt = title, attrs = Modifier.classNames("w-100").toAttrs())
        Div(Modifier.classNames("carousel-caption").toAttrs()) {
            Div(Modifier.classNames("container").toAttrs()) {
                Div(Modifier.classNames("row", "justify-content-center").toAttrs()) {
                    Div(Modifier.classNames("col-lg-8").toAttrs()) {
                        H1(Modifier.classNames("display-1", "text-white", "mb-5", "animated", "slideInDown").toAttrs()) {
                            Text(title)
                        }
                        P(Modifier.classNames("fs-5", "text-white", "mb-4", "pb-2", "animated", "slideInLeft").toAttrs()) {
                            Text(subtitle)
                        }
                        A(href = "/services", attrs = Modifier.classNames("btn", "btn-primary", "py-3", "px-5", "animated", "slideInLeft").toAttrs()) {
                            Text(buttonText)
                        }
                    }
                }
            }
        }
    }
}
